module.exports = __webpack_public_path__ + "static/No-Scene-zine-issue-1-c83c879cccc91e2d02d2586e4f053e06.pdf";